// The first client render of a pre-rendered page must equal the build's (ADR-0050): browser-only state -
// the URL hash, localStorage, window.location - is read only once this is true.
import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/** false on the server and while hydrating, true afterwards and in plain client renders. */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
